
import React, { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import cx from 'classnames';
import * as yup from 'yup';

import { history } from 'store/RouteState';
import UIState from 'store/UIState';
import { ModalTypes } from 'constants/constants';

import User from 'store/models/User';

import Modal, { ModalContent, ModalHeader, ModalTitle, ModalActions } from 'components/Modal';
import TextInput from 'components/forms/TextInput';
import { ServerErrors } from 'components/forms/Error';
import Button, { ButtonListCenter, TwitchLoginButton } from 'components/Button';


const FIELDS = ['username', 'password'];

const schema = yup.object().shape({
  username: yup.string().min(5).required(),
  password: yup.string().required(),
});



// ======================
// COMPONENT
// ====================== 

const LoginModal = ({data, onClose,...props}) => {
  const dispatch = useDispatch();
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [edits, setEdits] = useState({});
  const [savingEmail, setSavingEmail] = useState(false);
  const [savingTwitch, setSavingTwitch] = useState(false);

  const onChange = (value, name) => {
    setValues({...values, [name]: value});
    setEdits({...edits, [name]: true});
  }

  const onSubmit = async () => {
    let v;
    setSavingEmail(true);
    try {
      v = await schema.validate(values, {abortEarly: false});
    } catch(err) {
      setSavingEmail(false);
      setErrors(_.reduce(err.inner, (acc, e) => _.set(acc, e.path, e.errors), {}));
      return;
    }
    try {
      await dispatch(User.actions.loginUser(v.username, v.password));
      onClose?.();
      history.push('/dashboard');
    } catch (err) {
      setSavingEmail(false);
      setErrors({server: err.message});
    }
  }

  const onForgotPassword = async (e) => {
    e.preventDefault();
    dispatch(UIState.actions.closeModal(ModalTypes.LOGIN));
    dispatch(UIState.actions.showModal(ModalTypes.FORGOT_PASSWORD));
  }

  const onTwitchAuth = e => {
    e.preventDefault();
    setSavingTwitch(true);
    dispatch(User.actions.twitchAuth())
      .then(() => dispatch(UIState.actions.closeModal()));
  }

  const handleOnSuccess = () => {
    if(data?.to) {
      this.navigateTo(data?.to);
    } else {
      dispatch(UIState.actions.closeModal());
    }
  }


  return (
    <Modal className="modal login">
      <ModalHeader>
        <ModalTitle>Log In To HappyStreams</ModalTitle>
      </ModalHeader>
      <ModalContent>
        <ServerErrors errors={errors} />
        <form onSubmit={onSubmit}>
          <TextInput
            label="Username or Email"
            name="username"
            focused={true}
            value={values.username}
            errors={errors.username}
            onSubmit={onSubmit}
            onChange={onChange}/>
          <TextInput
            label="Password"
            name="password"
            type="password"
            value={values.password}
            errors={errors.password}
            onSubmit={onSubmit}
            onChange={onChange}/>
        </form>
        <ButtonListCenter className="email-action">
          <Button size="l"
            onClick={onSubmit}
            loading={savingEmail}>Login With Email</Button>
        </ButtonListCenter>
        <div className="forgot-password"><a href="#" onClick={onForgotPassword}>Forgot Password</a></div>
        <div className="social-label">Or using Twitch</div>
        <ButtonListCenter className="social">
          <TwitchLoginButton loading={savingTwitch} onClick={onTwitchAuth} />
        </ButtonListCenter>
      </ModalContent>
    </Modal>);
}
export default LoginModal;
